import { api } from "./authService";

// IMPORTANT: api.baseURL already contains '/api' — never prefix with '/api' here.
const BASE = "/semester-notes";

async function getNotes(learnerId, semesterId) {
  const res = await api.get(BASE, { params: { learnerId, semesterId } });
  return res.data;
}

async function createNote(payload) {
  const res = await api.post(BASE, payload);
  return res.data;
}

async function updateNote(id, payload) {
  const res = await api.patch(`${BASE}/${id}`, payload);
  return res.data;
}

async function deleteNote(id) {
  await api.delete(`${BASE}/${id}`);
}

const semesterNoteService = {
  getNotes,
  createNote,
  updateNote,
  deleteNote,
};

export default semesterNoteService;
